/* global _ */

class Errors {

  constructor() {
    this.errors = {};
  }

  hasErrors() {
    return !_.isEmpty(this.errors);
  }

  hasError(key) {
    return this.errors[key] !== undefined;
  }

  getError(key) {
    return this.errors[key];
  }

  getFirstError(key) {
    const error = this.getError(key);
    return (error === undefined) ? undefined : error[0];
  }

  setError(key, error) {
    this.errors[key] = error;
    return this;
  }

  setErrors(errors) {
    this.errors = errors;
    return this;
  }

  clearError(key) {
    return this.setError(key, undefined);
  }

  clearErrors() {
    this.errors = {};
    return this;
  }
}

export default Errors;



// WEBPACK FOOTER //
// ./src/js/helpers/errors.js